import React from "react";
import { useSelector } from "react-redux";
import { roles } from "@icarius-utils/constants";
import ChangePinDialog from "@icarius-common/changePinDialog";
import MyCertificatesAndReceiptsDialog from "@icarius-common/myCertificatesAndReceiptsDialog/components/index";
import MyDigitalDocumentsDialog from "@icarius-common/myDigitalDocumentsDialog/components/index";
import RequestDocumentsDialog from "@icarius-common/requestDocumentsDialog";
import MyVacations from "@icarius-common/myVacationsDialog";
import RegisterAssistanceDialog from "@icarius-common/registerAssistanceDialog";
import SocietySelectDialog from "@icarius-pages/login/components/societySelectDialog";
import { getAssistanceData, getUserRole } from "@icarius-app/selectors";
import { getHasToChangePin } from "@icarius-pages/login/selectors";
import ModalAbout from "./modalAbout";
import TimezoneDialog from "./timezoneDialog/index";
import ChangeRoleDialog from "@icarius-app/components/wrapper/dialogs/changeRoleDialog";

const DialogContainer = ({ dialogsState, changeSocietyData }) => {
    const assistanceData = useSelector(getAssistanceData);
    const hasToChangePin = useSelector(getHasToChangePin);
    const role = useSelector(getUserRole);

    const changePinDialogIsOpenOrResetPin = dialogsState.changePinDialogIsOpen || hasToChangePin;
    const isCollaborator = role && role === roles.collaborator;

    return (
        <>
            {dialogsState.assistanceDialogIsOpen && (
                <RegisterAssistanceDialog
                    open={dialogsState.assistanceDialogIsOpen}
                    assistanceData={assistanceData}
                    handleClose={() => dialogsState.setAssistanceDialogIsOpen(false)}
                />
            )}
            {changePinDialogIsOpenOrResetPin && (
                <ChangePinDialog
                    open={changePinDialogIsOpenOrResetPin}
                    onClose={() => dialogsState.setChangePinDialogIsOpen(false)}
                    hideClose={hasToChangePin}
                />
            )}
            {dialogsState.aboutUsDialogIsOpen && (
                <ModalAbout
                    open={dialogsState.aboutUsDialogIsOpen}
                    handleClose={() => dialogsState.setAboutUsDialogIsOpen(false)}
                />
            )}
            {isCollaborator && dialogsState.myVacationsDialogIsOpen && (
                <MyVacations
                    open={dialogsState.myVacationsDialogIsOpen}
                    handleClose={() => dialogsState.setMyVacationsDialogIsOpen(false)}
                />
            )}
            {isCollaborator && dialogsState.myCertificatesDialogIsOpen && (
                <MyCertificatesAndReceiptsDialog
                    open={dialogsState.myCertificatesDialogIsOpen}
                    isCertificate={true}
                    handleClose={() => dialogsState.setMyCertificatesDialogIsOpen(false)}
                />
            )}
            {isCollaborator && dialogsState.myReceiptsDialogIsOpen && (
                <MyCertificatesAndReceiptsDialog
                    open={dialogsState.myReceiptsDialogIsOpen}
                    isCertificate={false}
                    handleClose={() => dialogsState.setMyReceiptsDialogIsOpen(false)}
                />
            )}
            {isCollaborator && dialogsState.myHistoricalReceiptsDialogIsOpen && (
                <MyCertificatesAndReceiptsDialog
                    open={dialogsState.myHistoricalReceiptsDialogIsOpen}
                    isCertificate={false}
                    isHistorical={true}
                    handleClose={() => dialogsState.setMyHistoricalReceiptsDialogIsOpen(false)}
                />
            )}
            {dialogsState.digitalDocumentsIsOpen && (
                <MyDigitalDocumentsDialog
                    open={dialogsState.digitalDocumentsIsOpen}
                    handleCloseDialog={() => dialogsState.setDigitalDocumentsIsOpen(false)}
                />
            )}
            {dialogsState.requestDocumentsDialogIsOpen && (
                <RequestDocumentsDialog
                    open={dialogsState.requestDocumentsDialogIsOpen}
                    handleClose={() => dialogsState.setRequestDocumentsDialogIsOpen(false)}
                />
            )}
            {changeSocietyData.societyOptions?.length > 1 && changeSocietyData.changeSocietyDialogIsOpen && (
                <SocietySelectDialog
                    open={changeSocietyData.changeSocietyDialogIsOpen}
                    handleCloseDialog={changeSocietyData.handleCloseChangeSocietyDialog}
                    handleCancelDialog={changeSocietyData.handleCloseChangeSocietyDialog} // en este caso es igual al close
                    handleConfirm={changeSocietyData.handleChangeSociety}
                    actualSociety={changeSocietyData.societySelected}
                    options={changeSocietyData.societyOptions}
                />
            )}
            {dialogsState.timezoneDialogIsOpen && (
                <TimezoneDialog
                    open={dialogsState.timezoneDialogIsOpen}
                    handleClose={() => dialogsState.setTimezoneDialogIsOpen(false)}
                />
            )}
            {dialogsState.changeRoleDialogIsOpen && (
                <ChangeRoleDialog
                    open={dialogsState.changeRoleDialogIsOpen}
                    handleClose={() => dialogsState.setChangeRoleDialogIsOpen(false)}
                />
            )}
        </>
    );
};

export default DialogContainer;
